"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var package_json_1 = require("../package.json");

var mainnet_1 = __importDefault(require("./tokens/mainnet"));

var testnet_1 = __importDefault(require("./tokens/testnet"));

var getTokens_1 = __importStar(require("./tokens/getTokens"));

var parsed = package_json_1.version.split('.');
exports["default"] = {
  name: 'Energiswap Default Token List',
  timestamp: new Date().toISOString(),
  version: {
    major: +parsed[0],
    minor: +parsed[1],
    patch: +parsed[2]
  },
  tags: {},
  keywords: ['energiswap', 'default'],
  tokens: __spreadArray(__spreadArray([], mainnet_1["default"], true), testnet_1["default"], true),
  utility: {
    getTokens: function getTokens(network) {
      return (0, getTokens_1["default"])(network);
    },
    NODE_API: getTokens_1.NODE_API,
    MULTICALL_ABI: getTokens_1.MULTICALL_ABI,
    MULTICALL_NETWORKS: getTokens_1.MULTICALL_NETWORKS
  }
};